import { getAuthAxiosBackend } from "../../helpers/axios"

class SacrificerServices{

    get(id){
        return getAuthAxiosBackend().get('pilgrimage/sacrificers/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('pilgrimage/sacrificers', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('pilgrimage/sacrificers/' + id)
    }
}

export default new SacrificerServices()